import { css, html, LitElement } from "lit";
import templateJsonStore from "./TemplateJsonStore";
import { clearTrashbox } from "./TemplateJsonSlice";

/**
 * このクラスはTemplateContainerで使う予定だったが、タッチイベントがうまく動かなかったのでTemplateContainerの中にこのクラスと同等のものを実装して解決したため、不要となった
 */
class TemplateTrashBox extends LitElement {
    static styles = css`
        :host{
            position: fixed;
            display: flex;
            border-radius: 10px;
            box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 5px;
            flex-direction: column;
            background: rgba(0, 0, 0, 0.77);
            height: 200px;
            width: 250px;
        }

        .sub-title {
            display: flex;
            justify-content: center;
        }
        
        .node {
            border: 1px solid #ccc;
            padding: 0px 0px 0px 10px;
            margin: 0px 0px 5px 0px;
            background-color: #f9f9f9;
            border-radius: 5px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            padding-right: 0px;
            margin-right: 0px;
            position: relative;
            user-select: none;
        }

        .delete-button{
            position: absolute;
            font-size: small;
            border-radius: 12px;
            left: 2px;
            top: 2px;
            background: white;
        }
    
        .sub-title-text {
            border-bottom: 1px solid rgb(207, 207, 207);
            width: 80%;
            text-align: center;
            color: white;
        }

        .panel {
            height: 100%;
            padding: 5px;
            margin: 5px;
            display: flex;
            flex-direction: column;
            background-color: rgb(255, 255, 255);
            box-sizing: border-box;
            user-select: none;
            border-width: 1px;
            border-style: solid;
            border-color: rgb(204, 204, 204);
            border-radius: 0px 0px var(--sub-margin) var(--sub-margin);
            overflow-y: auto;
        }

        .node-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            margin-bottom: 5px;
        }
          
        .node-title-left {
            display: flex;
            flex-direction: column;
        }
        
        .node-title-right {
            display: flex;
            align-items: center;
        }
        
        .label-id {
            font-size: small;
            color: #917bff;
        }

        .node-label-tag-container {
            display: flex;
            flex-direction: row;
            align-items: flex-end;
            flex-wrap: nowrap;
        }

        .non-trash-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
        }

        .non-trush-message {
            color: #c5c5c5;
        }
    `;

    constructor() {
        super();

        templateJsonStore.subscribe(this.templateJsonstoreChanged.bind(this))
    }

    templateJsonstoreChanged() {
        this.requestUpdate();
    }

    /**
     * 空にするボタンの処理
     * @returns 
     */
    handleDeleteButton(event) {
        event.stopPropagation();

        //確認メッセージをを表示
        if (!confirm("ゴミ箱を空にしますか？")) {
            return;
        }
        templateJsonStore.dispatch(clearTrashbox());
    }

    render() {
        const trushBoxItems = templateJsonStore.getState().templateJson.trashbox;
        return html`
        <div class="sub-title">
            ${trushBoxItems.length !== 0 ? html`<button class="delete-button" @click="${this.handleDeleteButton}">空にする</button>` : ""}
            <div class="sub-title-text">ゴミ箱</div>
        </div>
        <div class="panel">
            ${trushBoxItems.length === 0 ? html`
                <div class="non-trash-container">
                    <div class="non-trush-message">ゴミ箱は空です</div>
                </div>` : ""}
            ${trushBoxItems.map(trashBoxItem => {
            let explain = "";
            if (!trashBoxItem) {
                explain = "";
            } else if (trashBoxItem.explain !== "") {
                explain = trashBoxItem.explain;
            } else {
                explain = trashBoxItem.tagName;
            }

            return html`
            <div class="node" data-node-id="${trashBoxItem.id}" data-node-type="${trashBoxItem.tagName}">
                <div class"node-title">
                    <div class="label-id">id:${trashBoxItem.domId}</div>
                </div>
                <div class="node-label-tag-container">
                    <div class="node-label-explain">${explain}</div>
                </div>
            </div>`})}
        </div>
        `
    }
}

customElements.define('template-trash-box', TemplateTrashBox);